<!-- 年度节能情况 -->
<template>
  <div class="month-chart">
    <div class="chart" ref="chart">
    </div>
    <div style="position: absolute;right: 180px;top: 20px;">
      <el-date-picker v-model="dt" type="year" :clearable="false" style="width: 120px" @change="query"></el-date-picker>
    </div>
  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import * as echarts from 'echarts';

export default {
  extends: BaseVue,
  components: {},

  props: {
    deviceCode : {
      required: true
    }
  },

  data() {
    let xSize = "53%";
    let ySize = "60%";
    let symbolSize = 2.5;
    return {
      chart: null,
      dt: new Date(),
      option: {
        title: {
          text: "年度节电情况",
          left: "center",
          top: 20
        },
        color: ['#2b85e4', '#19be6b','#ed4014'],
        toolbox: {
          show: true,
          left: 'right',
          top: 10,
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        grid: [
          {left: 50, right: xSize, bottom: ySize, top: 80},
          {left: xSize, bottom: ySize, top: 80, right: 50},
          {left: 50, right: xSize, top: ySize, bottom: 30},
          {left: xSize, top: ySize, right: 50, bottom: 30}
        ],
        xAxis: [
          {type: 'category', gridIndex: 0, name: '月份', boundaryGap: false, axisLabel: {formatter: "{value}月"}},
          {type: 'category', gridIndex: 1, name: '月份', boundaryGap: true, axisLabel: {formatter: "{value}月"}},
          {type: 'category', gridIndex: 2, name: '月份', boundaryGap: false, axisLabel: {formatter: "{value}月"}},
          {type: 'category', gridIndex: 3, name: '月份', boundaryGap: false, axisLabel: {formatter: "{value}月"}}
        ],
        yAxis: [
          {type: 'value', gridIndex: 0, name: '耗电量'},
          {type: 'value', gridIndex: 1, name: '节电量'},
          {type: 'value', gridIndex: 2, name: '节电率'},
          {type: 'value', gridIndex: 3, name: '节电金额'}
        ],
        dataset: {
          dimensions: [
            {name: '月份', type: 'ordinal'},
            '耗电量',
            '节电量',
            '节电率',
            '节电金额'
          ],
          source: []
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 30,
            symbolSize: symbolSize,
            xAxisIndex: 0,
            yAxisIndex: 0,
            encode: {
              x: '月份',
              y: '耗电量',
              tooltip: [1, 2, 3, 4]
            }
          },
          {
            type: 'bar',
            barMaxWidth: 30,
            symbolSize: symbolSize,
            xAxisIndex: 1,
            yAxisIndex: 1,
            encode: {
              x: '月份',
              y: '节电量',
              tooltip: [1, 2, 3, 4]
            }
          },
          {
            type: 'bar',
            barMaxWidth: 30,
            symbolSize: symbolSize,
            xAxisIndex: 2,
            yAxisIndex: 2,
            encode: {
              x: '月份',
              y: '节电率',
              tooltip: [1, 2, 3, 4]
            }
          },
          {
            type: 'bar',
            barMaxWidth: 30,
            symbolSize: this.symbolSize,
            xAxisIndex: 3,
            yAxisIndex: 3,
            encode: {
              x: '月份',
              y: '节电金额',
              tooltip: [1, 2, 3, 4]
            }
          }
        ]
      }
    }
  },
  created() {
    this.$nextTick(()=>{
      this.chart = echarts.init(this.$refs["chart"]);
      this.chart.setOption(this.option);
    });
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.postForm("/device-month-info/deviceMonthInfoByYear", {
        deviceCode: this.deviceCode,
        y: this.dt.getFullYear()
      }, true).then(dr => {
        this.option.title.text = this.dt.getFullYear()+"年度节电情况";
        let data = [["月份","耗电量","节电量","节电率","节电金额"]];
        dr.rows.forEach((item => {
          data.push([item.m,item.monthKwh || 0,item.saveKwh || 0,item.savePercent || 0,item.saveMoney || 0]);
        }));
        this.option.dataset.source = data;
        this.refresh();
      }).finally(()=>{
        this.loading = false;
      });
    },
    refresh() {
      this.chart.setOption(this.option);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../css/variables";
.month-chart {
  padding: 10px;
  position: relative;
  border: 1px solid $color-border-primary;
  border-radius: 5px;
  margin-bottom: 20px;
  .chart {
    min-height: 600px;
  }
}
</style>
